// Chuyến của tài xế (dữ liệu mẫu theo board Mint-Mov-Phone). Chỉ đọc; thao tác giả lập giữ trong bộ nhớ.

export type Day = 'yest' | 'today' | 'tmr';

export const STEPS = ['Đi lấy cont', 'Tại depot', 'Đến kho', 'Rời kho', 'Về cảng', 'Hạ cont', 'Xong'] as const;
export const DONE = STEPS.length; // p >= 7 là đã xong

export interface MovTrip {
  id: string;
  no: string;
  cus: string;
  cont: string;
  time: string;
  /** bước hiện tại 0..7 */
  p0: number;
  /** nhiệt độ yêu cầu của cont lạnh (°C); không có = cont thường */
  rf?: number;
  pts: readonly [kind: string, place: string][];
}

export const DRIVER = { plate: '51C-482.17', mooc: '51R-093.62', shift: 'Ca 06:00 – 18:00', duty: 'THANH', dutyPhone: '0900000001' } as const;

export const TRIPS: Record<Day, readonly MovTrip[]> = {
  yest: [
    { id: 'y09', no: 'TRF2610051', cus: 'Dệt may An Phú', cont: '1×40HC · YML', time: '06:30', p0: 7, pts: [['Lấy rỗng', 'Depot Phước Long'], ['Đóng hàng', 'Kho An Phú, Dĩ An'], ['Hạ hàng', 'Cảng Cát Lái']] },
    { id: 'y12', no: 'TRF2610054', cus: 'Nhựa Đông Á', cont: '1×20GP · Wan Hai', time: '13:00', p0: 7, pts: [['Lấy rỗng', 'Depot Tân Cảng'], ['Đóng hàng', 'Kho Nhựa Đông Á, Long An'], ['Hạ hàng', 'Cảng Cát Lái']] },
  ],
  today: [
    { id: 't18', no: 'TRF2610078', cus: 'SAVITA', cont: '1×40HC · YML · TGHU8123457', time: '06:00', p0: 2, pts: [['Lấy rỗng', 'ICD Phước Long 3, TP Thủ Đức'], ['Đóng hàng', 'Kho SAVITA, Bình Dương'], ['Hạ hàng', 'Cát Lái Giang Nam · cut-off 23/Oct/2026 23:59']] },
    { id: 't21', no: 'TRF2610096', cus: 'Dệt may An Phú', cont: '1×40HC · YML', time: '13:30', p0: 0, pts: [['Lấy rỗng', 'Depot Transimex, TP Thủ Đức'], ['Đóng hàng', 'Kho An Phú, Dĩ An, Bình Dương'], ['Hạ hàng', 'Cảng Cát Lái · cut-off 24/Oct/2026 11:00']] },
    { id: 't24', no: 'TRF2610097', cus: 'Gỗ Trường Thành Phát', cont: '1×40HC · YML · cắt mooc', time: '19:00', p0: 0, pts: [['Lấy cont', 'Bãi HANA Long Bình · mooc 51R-101.44 đã đóng hàng'], ['Giao', 'Không đóng hàng (cắt mooc)'], ['Hạ hàng', 'Cảng Cái Mép (VNCMT)']] },
  ],
  tmr: [
    { id: 'm03', no: 'TRF2610098', cus: 'Nội thất Hòa Bình', cont: '1×40HC · KMTC', time: '07:00', p0: 0, pts: [['Lấy rỗng', 'Depot Phước Long'], ['Đóng hàng', 'Kho Hòa Bình, Thuận An'], ['Hạ hàng', 'Cảng Cát Lái']] },
  ],
};

export type StatusTone = 'ok' | 'warn' | 'pri';

export function statusOf(p: number): { label: string; tone: StatusTone } {
  if (p >= DONE) return { label: 'Xong', tone: 'ok' };
  if (p === 0) return { label: 'Chờ', tone: 'warn' };
  return { label: 'Đang chạy', tone: 'pri' };
}

export function progressLabel(p: number, day: Day): string {
  if (p >= DONE) return `Đã xong ${DONE}/${DONE} bước`;
  if (day === 'tmr') return 'Dự kiến · điều độ chốt trước 16:00 hôm nay';
  return `Bước ${p + 1}/${DONE} · ${STEPS[p]}`;
}

/** Nút chính của thẻ: chỉ hôm nay và chuyến chưa xong. */
export function nextLabel(p: number, day: Day): string | null {
  if (day !== 'today' || p >= DONE) return null;
  return p === 0 ? 'Bắt đầu chuyến' : `Tiếp tục: ${STEPS[p]}`;
}
